// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import i18n from '@/locale'
import config from '@/config'
// import VueSocketIO from 'vue-socket.io'
import importDirective from '@/directive'
import installPlugin from '@/plugin'
import 'view-design/dist/styles/iview.css'
import './index.less'
import '@/assets/icons/iconfont.css'
import BaiduMap from 'vue-baidu-map'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.prototype.$bus=new Vue({
  data(){
    return {
      currpage:1,
      parentNumber:'',
      openlist:['四川'],
      pointchildrenlist:[
        1
      ],
      keypointlist:[
        
      ]
    }
  },
})
// 192.168.1.164
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'ws://192.168.1.164:6820',
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_', //为vuex设置的两个前缀
//     mutationPrefix: 'SOCKET_'
// },
// },
// ))
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})

Vue.use(BaiduMap, {
  ak: 'XvYWaCqDGIetppHHSm1wzhiPrA8ODno0'
})